import { MoreVertical, type LucideIcon } from 'lucide-react';
import { Dropdown } from './dropdown';

export interface AcaoLinha {
  rotulo: string;
  icone: LucideIcon;
  aoEscolher: () => void;
  /** Ação que remove ou desativa: sai em vermelho e separada das outras. */
  destrutiva?: boolean;
}

/**
 * Menu "⋯" de uma linha da tabela.
 *
 * Existe porque nem toda ação cabe no clique da linha. O clique abre o
 * registro — que é o que 90% das vezes se quer — e as outras operações
 * (desativar, reativar) precisam de um lugar que não dispute com ele. Botões
 * soltos na linha resolveriam, mas com três ações a coluna vira uma barra de
 * ferramentas e a informação da linha encolhe.
 *
 * Usa o `Dropdown` do projeto, que já é portalado: dentro do `overflow-x-auto`
 * da tabela, um painel comum seria cortado na borda da caixa.
 */
export function MenuLinha({ acoes }: { acoes: readonly AcaoLinha[] }) {
  if (acoes.length === 0) return null;

  return (
    <Dropdown
      rotulo="Ações desta linha"
      classeGatilho="text-tinta-500 hover:bg-marca-600/10 hover:text-tinta-900 inline-flex size-8 items-center justify-center rounded-lg transition-colors"
      gatilho={<MoreVertical className="size-4" aria-hidden />}
      classePainel="w-48 p-1"
    >
      {(fechar) =>
        acoes.map((acao) => (
          <button
            key={acao.rotulo}
            type="button"
            onClick={() => {
              acao.aoEscolher();
              fechar();
            }}
            className={`flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors ${
              acao.destrutiva
                ? 'text-erro-600 hover:bg-erro-600/10'
                : 'text-tinta-700 hover:bg-marca-600/[0.07]'
            }`}
          >
            <acao.icone className="size-4 shrink-0" aria-hidden />
            {acao.rotulo}
          </button>
        ))
      }
    </Dropdown>
  );
}
